(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["ec-filter-products"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('ec-filter-products')) {
    customElements.define(
      'ec-filter-products',
      class extends HTMLElement {
        connectedCallback() {
          this.pills = [...this.querySelectorAll('[data-filter]')];
          this.cards = [...this.querySelectorAll('.ec-fp__card')];
          this.pills.forEach((pill) => pill.addEventListener('click', () => this.apply(pill)));
        }
        apply(active) {
          const tag = active.dataset.filter;
          this.pills.forEach((p) => {
            const on = p === active;
            p.classList.toggle('is-active', on);
            p.setAttribute('aria-pressed', String(on));
          });
          this.classList.toggle('is-filtered', !!tag);
          this.cards.forEach((card) => {
            const tags = (card.dataset.tags || '').split(' ');
            card.classList.toggle('is-match', !!tag && tags.includes(tag));
          });
        }
      }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ec-guide"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('ec-guide')) {
    customElements.define(
      'ec-guide',
      class extends HTMLElement {
        connectedCallback() {
          this.q1 = [...this.querySelectorAll('[data-q1]')];
          this.q2 = [...this.querySelectorAll('[data-q2]')];
          this.step2 = this.querySelector('[data-step2]');
          this.results = [...this.querySelectorAll('[data-result-id]')];

          this.q1.forEach((btn) =>
            btn.addEventListener('click', () => {
              this.press(this.q1, btn);
              this.press(this.q2, null);
              if (btn.dataset.mode === 'q2') {
                this.step2.hidden = false;
                this.show(null);
              } else {
                this.step2.hidden = true;
                this.show(btn.dataset.result);
              }
            })
          );
          this.q2.forEach((btn) =>
            btn.addEventListener('click', () => {
              this.press(this.q2, btn);
              this.show(btn.dataset.result);
            })
          );
          this.querySelectorAll('[data-reset]').forEach((btn) =>
            btn.addEventListener('click', () => {
              this.press(this.q1, null);
              this.press(this.q2, null);
              this.step2.hidden = true;
              this.show(null);
              if (this.q1[0]) this.q1[0].focus();
            })
          );
        }
        press(group, active) {
          group.forEach((b) => b.setAttribute('aria-pressed', String(b === active)));
        }
        show(id) {
          this.results.forEach((r) => (r.hidden = !id || r.dataset.resultId !== String(id)));
        }
      }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ec-hero-media"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('ec-hero-media')) {
    customElements.define(
      'ec-hero-media',
      class extends HTMLElement {
        connectedCallback() {
          const v = this.querySelector('video');
          if (!v) return;
          v.muted = true;
          v.playsInline = true;
          v.removeAttribute('controls');
          if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
            v.removeAttribute('autoplay');
            v.pause();
          }
          const replay = this.querySelector('[data-replay]');
          const sound = this.querySelector('[data-sound]');
          if (replay) {
            replay.addEventListener('click', () => {
              v.currentTime = 0;
              const p = v.play();
              if (p && p.catch) p.catch(() => {});
            });
          }
          if (sound) {
            sound.addEventListener('click', () => {
              v.muted = !v.muted;
              sound.textContent = v.muted ? 'Zapnout zvuk' : 'Vypnout zvuk';
              sound.setAttribute('aria-pressed', String(!v.muted));
              if (v.paused) v.play().catch(() => {});
            });
          }
        }
      }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ec-hero"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('ec-hero-slider')) {
    class EcHeroSlider extends HTMLElement {
      connectedCallback() {
        this.slides = [...this.querySelectorAll('[data-slide]')];
        this.dots = [...this.querySelectorAll('[data-dot]')];
        this.index = 0;
        this.interval = parseInt(this.dataset.interval, 10) || 5000;

        this.dots.forEach((dot) => {
          dot.addEventListener('click', () => {
            this.show(parseInt(dot.dataset.dot, 10));
            this.restart();
          });
        });

        this.reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
        this.restart();

        // V editoru tématu zobrazit vybranou fotku
        document.addEventListener('shopify:block:select', (e) => {
          const i = this.slides.findIndex((s) => s.contains(e.target) || s === e.target);
          if (i > -1) {
            this.show(i);
            this.stop();
          }
        });
        document.addEventListener('shopify:block:deselect', () => this.restart());
      }

      disconnectedCallback() {
        this.stop();
      }

      show(i) {
        if (!this.slides.length) return;
        this.index = (i + this.slides.length) % this.slides.length;
        this.slides.forEach((s, n) => s.classList.toggle('is-active', n === this.index));
        this.dots.forEach((d, n) => d.classList.toggle('is-active', n === this.index));
      }

      stop() {
        clearInterval(this.timer);
      }

      restart() {
        this.stop();
        if (this.reduced || this.slides.length < 2) return;
        this.timer = setInterval(() => this.show(this.index + 1), this.interval);
      }
    }
    customElements.define('ec-hero-slider', EcHeroSlider);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ec-product-spotlight"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('ec-spotlight')) {
    const bars = new Set();
    const update = () => {
      const narrow = window.innerWidth < 760;
      const mid = window.innerHeight * 0.5;
      let shown = null;
      bars.forEach((el) => {
        const r = el.getBoundingClientRect();
        if (narrow && !shown && r.top < mid && r.bottom > mid * 0.4) shown = el;
      });
      bars.forEach((el) => {
        const on = el === shown;
        el.bar.classList.toggle('is-visible', on);
        el.bar.setAttribute('aria-hidden', String(!on));
        const btn = el.bar.querySelector('button');
        if (btn) btn.tabIndex = on ? 0 : -1;
      });
      document.body.classList.toggle('ec-has-bar', !!shown);
    };
    window.addEventListener('scroll', update, { passive: true });
    window.addEventListener('resize', update);

    customElements.define(
      'ec-spotlight',
      class extends HTMLElement {
        connectedCallback() {
          this.bar = this.querySelector('[data-bar]');
          if (this.bar && this.dataset.sticky === 'true') {
            bars.add(this);
            update();
          }
        }
        disconnectedCallback() {
          bars.delete(this);
          update();
        }
      }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
